/**
 * よくある質問ページ
 * カテゴリーの列数
 */
export const ROWS = {
  SP: 2,
  TAB: 4,
  PC: 5,
} as const;
